import { buildModelManager } from "../builder.js";
const DefaultAdminAssistantAuditLogSelection = {
  __typename: true,
  id: true,
  accessLevel: true,
  actionsTaken: true,
  assistantResponse: { markdown: true, truncatedHTML: true },
  createdAt: true,
  dataAccessed: true,
  duration: true,
  errorDetails: { markdown: true, truncatedHTML: true },
  flaggedForReview: true,
  institution: true,
  ipAddress: true,
  requestType: true,
  reviewNotes: { markdown: true, truncatedHTML: true },
  reviewedById: true,
  sessionId: true,
  successful: true,
  updatedAt: true,
  userAgent: true,
  userId: true,
  userMessage: { markdown: true, truncatedHTML: true }
};
const modelApiIdentifier = "adminAssistantAuditLog";
const pluralModelApiIdentifier = "adminAssistantAuditLogs";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAdminAssistantAuditLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAdminAssistantAuditLogSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAdminAssistantAuditLogSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAdminAssistantAuditLogSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAdminAssistantAuditLogSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAdminAssistantAuditLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAdminAssistantAuditLogSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAdminAssistantAuditLog",
    operationReturnType: "CreateAdminAssistantAuditLog",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      adminAssistantAuditLog: { required: false, type: "CreateAdminAssistantAuditLogInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAdminAssistantAuditLogSelection
  },
  {
    type: "action",
    operationName: "bulkCreateAdminAssistantAuditLogs",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateAdminAssistantAuditLogsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAdminAssistantAuditLogSelection
  },
  {
    type: "action",
    operationName: "updateAdminAssistantAuditLog",
    operationReturnType: "UpdateAdminAssistantAuditLog",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      adminAssistantAuditLog: { required: false, type: "UpdateAdminAssistantAuditLogInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAdminAssistantAuditLogSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateAdminAssistantAuditLogs",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateAdminAssistantAuditLogsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAdminAssistantAuditLogSelection
  },
  {
    type: "action",
    operationName: "deleteAdminAssistantAuditLog",
    operationReturnType: "DeleteAdminAssistantAuditLog",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAdminAssistantAuditLogs",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAdminAssistantAuditLog",
    operationReturnType: "UpsertAdminAssistantAuditLog",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      adminAssistantAuditLog: { required: false, type: "UpsertAdminAssistantAuditLogInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAdminAssistantAuditLogResult": { hasReturnType: false },
      "... on UpdateAdminAssistantAuditLogResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAdminAssistantAuditLogSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertAdminAssistantAuditLogs",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertAdminAssistantAuditLogsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAdminAssistantAuditLogSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "adminAssistantAuditLogGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AdminAssistantAuditLogManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAdminAssistantAuditLogSelection,
  operations
);
export {
  AdminAssistantAuditLogManager,
  DefaultAdminAssistantAuditLogSelection
};
//# sourceMappingURL=AdminAssistantAuditLog.js.map
